<template>
    <div class="preference content-container flex-column">
      <!-- Pasek menu -->
      <div class="d-flex preference-section-container no-content">
        <div class="preference-section"></div>
        <div class="content-wrap">
          <!-- <TopMenu /> -->
        </div>
      </div>
      
      <!-- Sekcja zmiany hasła -->
      <div class="d-flex preference-section-container">
        <div class="preference-section">
          <span>{{ t('password-change') }}</span>
        </div>
        <div class="content-wrap">
          <h3>{{ t('password-change') }}
            <small v-if="userLabel" class="muted"> - {{ userLabel }}</small>
          </h3>
          <div class="collapse show" id="passData">
            <div class="card-body">
              <!-- Formularz zmiany hasła -->
              <Form
                @submit="onSubmitPass"
                :validation-schema="schemaPass"
                v-slot="{ errors, isSubmitting }"
                :keepValues="false"
              >
                <div class="column d-flex justify-content-center user-data">
                  <div class="col-sm-6">
                    <!-- Pole stare hasło -->
                    <div class="form-group row">
                      <label class="col-sm-4 col-form-label">{{ t('password') }}:</label>
                      <div class="col-sm-8">
                        <Field
                          name="password"
                          type="password"
                          class="form-control"
                          v-model="form.password"
                          :class="{ 'is-invalid': errors.password }"
                        />
                        <div class="invalid-feedback">{{ errors.password }}</div>
                      </div>
                    </div>
                    <!-- Pole nowe hasło -->
                    <div class="form-group row">
                      <label class="col-sm-4 col-form-label">{{ t('new-password') }}:</label>
                      <div class="col-sm-8">
                        <Field
                          name="password2"
                          type="password"
                          class="form-control"
                          v-model="form.password2"
                          :class="{ 'is-invalid': errors.password2 }"
                        />
                        <div class="invalid-feedback">{{ errors.password2 }}</div>
                      </div>
                    </div>
                    <!-- Miernik siły hasła -->
                    <div class="form-group row">
                      <label class="col-sm-4 col-form-label">{{ t('password-strength-level') }}:</label>
                      <div class="col-sm-8">
                        <password-meter :password="form.password2" />
                        <div class="d-flex password-meter center-aligned justify-content-center">
                          <div class="col-sm-4">Słabe</div>
                          <div class="col-sm-4">Średnie</div>
                          <div class="col-sm-4">Silne</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6"></div>
                </div>
                <!-- Generator haseł i przyciski -->
                <div class="column d-flex justify-content-center">
                  <div class="form-group col">
                    <div class="form-group row">
                      <label class="col-sm-4 col-form-label">{{ t('password-proposal') }}:</label>
                      <div class="col-sm-8">
                        <Field
                          name="proposed"
                          type="text"
                          class="form-control"
                          v-model="form.proposed"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col generate-pass">
                    <div class="form-group row">
                      <div class="col-sm-4">
                        <!-- Przycisk generowania hasła -->
                        <button
                          type="button"
                          @click="generatePassword"
                          class="btn button-add-user generate"
                        >
                          {{ t('generate').toUpperCase() }}
                        </button>
                      </div>
                      <div class="col-sm-7">
                        <!-- Przycisk wstawienia wygenerowanego hasła -->
                        <button
                          type="button"
                          @click="usePassword"
                          class="btn button-add-user use-password"
                          :disabled="!form.proposed"
                        >
                          {{ t('use-suggested-password') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row d-flex flex-column align-items-center">
                    <div class="col-auto" v-if="errorMessage" style="margin-bottom: 1rem;">
                        <div class="process-error form-control">
                        {{ errorMessage }}
                        </div>
                    </div>
                    <div class="col-auto" v-if="successMessage" style="margin-bottom: 1rem;">
                        <div class="process-success form-control">
                        {{ successMessage }}
                        </div>
                    </div>
                    <div class="col-auto">
                        <!-- Przycisk zmiany hasła -->
                        <button
                        class="btn button-add-user"
                        :disabled="isSubmitting"
                        >
                        <span
                            v-show="isSubmitting"
                            class="spinner-border spinner-border-sm mr-1"
                        ></span>
                        {{ t('change-password') }}
                        </button>
                    </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import * as Yup from "yup";
  import { useI18n } from 'vue-i18n';
  import { Form, Field } from 'vee-validate';
  const { t } = useI18n();
  
  
  // Schemat walidacji dla zmiany hasła
  const schemaPass = Yup.object().shape({
    password: Yup.string().required(t('user-password-required')),
    password2: Yup.string().required(t('user-password-required')),
  });
  </script>
  
  <script>
  // import { ref } from "vue";
  import PasswordMeter from "vue-simple-password-meter";
  import { useErrorStore } from "@/stores/error.store";
  import { useUserStore } from "@/stores/user.store";
  import { useAuthStore } from "@/stores/auth.store";

  export default {
    name: "PasswordExpiredView",
    components: { PasswordMeter },
    data() {
      const userStore = useUserStore();
      return {
        userStore,
        userData: {},
        preferences: {},
        form: {
          password: "",
          password2: "",
          proposed: "",
        },
        getPasswordLength: 14,
        errorsStore: useErrorStore(),
        processSettingsSuccess: null,
        processSettingsError: null,
        processError: null,
        processSuccess: null,
      };
    },
    computed: {
        // Bezpieczne “proxy” – jeśli Twój error.store nazywa pola inaczej,
        // wystarczy tutaj dopisać alternatywne nazwy:
        errorMessage() {
          return (
              this.errorsStore?.errorMessage ||
              this.errorsStore?.message ||
              null
          );
        },
        successMessage() {
          return (
              this.errorsStore?.successMessage ||
              this.errorsStore?.messageSuccess ||
              null
          );
        },
        userLabel() {
          const u = this.userData || {};
          const fullName =[u.firstName, u.lastName].filter(Boolean).join(' ');
          // priorytet: username > email > Imię i nazwisko
          return u.username || u.email || fullName || '';
        },
    },
    async mounted() {
      // Pobierz dane użytkownika po załadowaniu widoku
      await this.userStore.self();
      this.userData = this.userStore.currentUser;
      this.preferences = this.userStore.preferences;
    },
    methods: {
      // Obsługa submitu dla zmiany hasła
      async onSubmitPass(values) {
        const userStore = useUserStore();

        const sendUser = {
          password: values.password,
          newPassword: values.password2,
        };
        this.errorsStore.clearErrorMessage();

        const updatedData = await userStore.updatePassword(sendUser);
        
        if (!updatedData.error) {
          this.errorsStore.showSuccessMessage(this.$t('updated'));
          const authStore = useAuthStore();
          await authStore.onPasswordChanged();
          setTimeout(() => this.$router.replace("/"), 1200);
        } else {
          this.errorsStore.showErrorMessage(updatedData.error);
        }
      },
      // Generator silnych haseł
      generatePassword() {
        const alphabet =
          "1234567890-=!@#$%^&*()_+qazwsxedcrfvtgbyhnujmik,ol.p;/[]QAZWSXEDCRFVTGBYHNUJMIKOL>P:?{'}|";
        let pass = "";
        for (let i = 0; i < this.getPasswordLength; i++) {
          pass += alphabet[Math.floor(Math.random() * alphabet.length)];
        }
        this.form.proposed = pass;
        return pass;
      },
      // Wstawienie wygenerowanego hasła do pola
      usePassword() {
        this.form.password2 = this.form.proposed;
      },
    },
  };
  </script>
  
  <style scoped>
  .process-error {
    color: darkred;
  }
  
  .process-success {
    color: #42b983;
  }
  
  .col-form-label {
    text-align: right;
  }
  
  .content-container > div {
    min-height: auto;
  }
  
  .content-wrap .collapse {
    margin-bottom: 20px;
  }
  
  .preference-section-container {
    width: 100%;
  }
  
  .preference-section {
    width: 365px;
    background: url("../assets/l-filter-bg.png") repeat-y right;
  }
  
  .preference-section > span {
    padding: 10px 25px;
    position: relative;
    display: block;
  }
  
  .content-wrap h3 {
    margin-bottom: 0;
    font-weight: bold;
    padding: 10px 20px;
    background-color: white;
  }
  
  .card-body .column {
    padding: 20px 30px;
  }
  
  .card-body .column > div {
    padding: 5px 20px;
  }
  
  .no-content {
    min-height: auto;
  }
  
  .icon {
    margin: 5px;
    height: 15px;
    width: 35px;
  }
  
  .icon-collapse {
    background: url("../assets/icons/zwin.png") no-repeat left top;
    width: 19px;
    height: 19px;
    position: absolute;
    cursor: pointer;
    right: 10px;
  }
  
  .collapsed.icon-collapse {
    background: url("../assets/icons/rozwin.png") no-repeat left top;
  }
  
  .phone-label {
    padding-left: 0;
    padding-right: 0;
  }
  
  .password-meter {
    font-size: 12px;
  }
  
  .generate-pass {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .button-add-user {
    padding: 0.5rem 1rem 0.5rem 1rem;
  }
  
  .generate {
    padding: .75rem 2rem .75rem 2rem;
  }
  
  .use-password {
    padding: .75rem 2rem .75rem 2rem;
  }
  </style>
  